<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  @change="
                    selectAllFromSelect('fruitInventoryForm.farm_id', farms);
                    showCalendar();
                  "
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="`farm-${option.id}-${index}`"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2 col-width">
                <label>{{ $t('production.included') }}</label>
                <br />
                <el-select
                  clearable
                  multiple
                  collapse-tags
                  @change="
                    selectAllFromSelect(
                      'fruitInventoryForm.dataTypes',
                      showColumns
                    )
                  "
                  filterable
                  class="select-primary custom-width-select shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.dataTypes"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in showColumns"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                v-if="isShowCalendar"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-calendar shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.calendar_sel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in calendars"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-2"
                style="padding-right: 0"
              >
                <label>{{ $t('common_words.initial_date') }}</label>
                <br />
                <el-select
                  :placeholder="`${$t('common_words.year')}...`"
                  clearable
                  @clear="fruitInventoryForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                v-if="fruitInventoryForm.year_sel_init"
              >
                <label style="color: white">0</label>
                <br />
                <el-select
                  :placeholder="`${$t('common_words.week')}...`"
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      fruitInventoryForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-2"
                style="padding-right: 0"
              >
                <label>{{ $t('common_words.final_date') }}</label>
                <br />
                <el-select
                  :placeholder="`${$t('common_words.year')}...`"
                  clearable
                  @clear="fruitInventoryForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                v-if="fruitInventoryForm.year_sel_end"
              >
                <label style="color: white">0</label>
                <br />
                <el-select
                  :placeholder="`${$t('common_words.week')}...`"
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="fruitInventoryForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      fruitInventoryForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="fruitInventory"
        :title="$t('production.fruit_inventory')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      rowspan="3"
                      v-if="fruitInventoryForm.farm_id.length < 2"
                      class="text-center p-3"
                      style="
                        font-weight: bolder;
                        font-size: 14px;
                        width: 180px !important;
                        max-width: 180px !important;
                      "
                    >
                      {{ $t('common_words.allotment') }}
                    </td>
                    <td
                      rowspan="3"
                      v-else
                      class="text-center p-3"
                      style="
                        font-weight: bolder;
                        font-size: 14px;
                        width: 180px !important;
                        max-width: 180px !important;
                      "
                    >
                      {{ $t('common_words.farm') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="
                        font-weight: bolder;
                        font-size: 14px;
                        width: 147.5px !important;
                      "
                    >
                      {{ $t('common_words.description') }}
                    </td>
                    <td
                      class="text-center p-3"
                      v-bind:style="{
                        fontSize: 'smaller',
                        whiteSpace: 'nowrap',
                        width: '95.62px !important',
                        backgroundColor: column.color_code,
                        color: column.color_text,
                      }"
                      v-for="(column, index) in reports.weeksColor"
                      :key="index"
                    >
                      <strong>{{ column.week }}</strong>
                    </td>
                    <td
                      class="text-center p-3"
                      style="
                        font-weight: bolder;
                        font-size: 14px;
                        width: 180px !important;
                        max-width: 180px !important;
                      "
                    >
                      {{ $t('common_words.total') }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in queriedData" :key="index">
                    <td class="text-center" style="height: 55px">
                      {{ data.lot_name }}
                    </td>
                    <td class="text-center" style="padding: 0px">
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('pocket')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{ $t('production.baggd') }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('cutting')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{ $t('production.harvest') }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('ringing')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{ $t('production.ringin') }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('stock')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{ $t('production.existence') }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('recobro')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{ $t('production.payment_due') }}(%)
                        </td>
                      </tr>
                    </td>

                    <td
                      class="text-center p-3"
                      style="padding: 0px !important"
                      v-for="(column, index) in reports.weeks"
                      :key="index"
                    >
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('pocket')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.pocket.data[index].value
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('cutting')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.cutting.data[index].value
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('ringing')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.ringing.data[index].value
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('stock')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.stock.data[index].value
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('recobro')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.recobro.data[index].value
                            )
                          }}
                        </td>
                      </tr>
                    </td>

                    <td class="text-center p-3" style="padding: 0px !important">
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('pocket')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.pocket.total
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('cutting')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.cutting.total
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('ringing')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.ringing.total
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('stock')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.stock.total
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        rowspan="1"
                        class="my-flex"
                        v-if="fruitInventoryForm.dataTypes.includes('recobro')"
                      >
                        <td class="text-center p-3 my-custom-td-style">
                          {{
                            new Intl.NumberFormat('en-US').format(
                              data.recobro.total
                            )
                          }}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
        </div>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import { Switch as LSwitch } from 'src/components';
import Fuse from 'fuse.js';
import Filter from 'src/components/Filter/Filters.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import paginationData from './paginationData';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup,
    LPagination,
    [Filter.name]: Filter,
    LSwitch,
  },
  computed: {
    calendars() {
      if (this.fruitInventoryForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.fruitInventoryForm.farm_id.forEach((elFarm) => {
            if (element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    ...paginationData.functions,
  },
  data() {
    return {
      activeName: '1',
      fruitInventoryForm: {
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        farm_id: [],
        calendar_sel: null,
        dataTypes: [],
      },
      searchQuery: '',
      fuseSearch: null,
      pagination: paginationData.pagination,
      reports: [],
      farms: [],
      years: [],
      valueCollapse: null,
      isShowCalendar: false,
      fruitInventory: false,
      showColumns: [],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
      this.showColumns = this.concatAll([
        { id: 'pocket', name: this.$t('production.baggd') },
        { id: 'cutting', name: this.$t('production.harvest') },
        { id: 'ringing', name: this.$t('production.ringin') },
        { id: 'stock', name: this.$t('production.existence') },
        { id: 'recobro', name: this.$t('production.payment_due') },
      ]);
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    verifyCalendar() {
      const farm_selected = this.farms.filter((farm) =>
        this.fruitInventoryForm.farm_id.includes(farm.id)
      );
      const calendar_ids = farm_selected
        .map((farm) => {
          if (farm.calendars.length > 0 && farm.calendars[0].id) {
            return farm.calendars[0].id;
          } else {
            return null;
          }
        })
        .filter((item) => item !== null);

      for (let i = 0; i < calendar_ids.length - 1; i++) {
        for (let j = 1; j < calendar_ids.length; j++) {
          if (calendar_ids[i] !== calendar_ids[j]) {
            SweetAlert.warning(
              i18n.t('sweet_alert.production.selected_farms_calendar')
            );
            return 0;
          }
        }
      }
    },

    showCalendar() {
      this.fruitInventoryForm.calendar_sel = null;
      this.fruitInventory = false;
      this.cuttingCatch = false;

      for (let index = 0; index < Object.values(this.farms).length; index++) {
        const element = Object.values(this.farms)[index];

        this.fruitInventoryForm.farm_id.forEach((elFarm) => {
          if (element.id != 0 && element.id == elFarm) {
            if (element.calendars.length > 1) {
              this.isShowCalendar = true;
              this.fruitInventoryForm.calendar_sel = null;
              this.fruitInventory = false;
            } else {
              if (element.calendars.length == 1) {
                this.fruitInventoryForm.calendar_sel = element.calendars[0].id;
                this.isShowCalendar = false;
              }
            }
          }
        });
      }

      this.isShowCalendar = false;
    },
    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },
    validate() {
      if (
        this.fruitInventoryForm.farm_id == null ||
        this.fruitInventoryForm.farm_id.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (this.fruitInventoryForm.year_sel_init == null) {
        return this.validationInputsRequired('year');
      } else if (this.fruitInventoryForm.week_sel_init == null) {
        return this.validationInputsRequired('week');
      } else if (this.fruitInventoryForm.year_sel_end == null) {
        return this.validationInputsRequired('year');
      } else if (this.fruitInventoryForm.week_sel_end == null) {
        return this.validationInputsRequired('week');
      } else if (this.fruitInventoryForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else if (this.rangeDate == null) {
        return this.validationInputsRequired('year');
      } else {
        this.verifyCalendar();
        this.loadFruitInventoryReport();
      }
    },
    loadFruitInventoryReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'summary/fruitinventory';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.reports = response.data;
            this.fuseSearch = new Fuse(this.reports.tableData, {
              useExtendedSearch: true,
              threshold: 0.6,
              keys: ['lot_name'],
            });
            this.fruitInventory = true;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },
    loadData() {
      this.pagination.currentPage = 1;
      let selected = this.fruitInventoryForm.dataTypes.filter((id) => id !== 0);

      let data = {
        farm: this.fruitInventoryForm.farm_id,
        init:
          parseInt(this.fruitInventoryForm.year_sel_init) * 100 +
          parseInt(this.fruitInventoryForm.week_sel_init),
        end:
          parseInt(this.fruitInventoryForm.year_sel_end) * 100 +
          parseInt(this.fruitInventoryForm.week_sel_end),
        showPocket: selected.includes('pocket'),
        showCutting: selected.includes('cutting'),
        showRinging: selected.includes('ringing'),
        showStock: selected.includes('stock'),
        showRecobro: selected.includes('recobro'),
      };
      return data;
    },

    exportToPDF() {
      let data = this.loadData();
      data.route = 'summary/reports/pdf';
      data.name_file = `${i18n.t('production.fruit_inventory')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'summary/reports/excel';
      data.name_file = `${i18n.t('production.fruit_inventory')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.fruitInventoryForm.dataTypes = [
            'pocket',
            'cutting',
            'ringing',
            'stock',
            'recobro',
          ];
          this.showColumns = this.concatAll([
            { id: 'pocket', name: this.$t('production.baggd') },
            { id: 'cutting', name: this.$t('production.harvest') },
            { id: 'ringing', name: this.$t('production.ringin') },
            { id: 'stock', name: this.$t('production.existence') },
            { id: 'recobro', name: this.$t('production.payment_due') },
          ]);

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('summary');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('summary');
  },
};
</script>

<style scoped>
.custom-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.my-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.my-custom-td-style {
  height: 55px;
  margin: 0px;
  width: 100%;
}

.table-responsive {
  max-height: 80vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}

@media (min-width: 1200px) {
  .col-width {
    max-width: 20%;
  }
}
</style>
